// A library that expose functions that allows vue pinia store to persist their state in localStorage.

export function set(key, value) {
    if (value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    else {
        localStorage.removeItem(key);
    }
}

export function get(key) {
    return JSON.parse(localStorage.getItem(key));
}

export function setWithTTL(key, value, ttlMinutes) {
    const item = {
        value,
        timestamp: Date.now(),
        ttl: ttlMinutes * 60 * 1000 // Convert minutes to milliseconds
    };
    localStorage.setItem(key, JSON.stringify(item));
}

export function getWithTTL(key) {
    const item = localStorage.getItem(key);
    if (!item) return null;

    const parsed = JSON.parse(item);
    const now = Date.now();

    // Check if the item has expired
    if (now - parsed.timestamp > parsed.ttl) {
        localStorage.removeItem(key);
        return null;
    }

    return parsed.value;
}
